/**
 * Canonical ordered category list for the Storage domain. Drives:
 *   - The order stories appear in the studio list view + the auto-generated
 *     `docs/snowy/CHAT_USER_STORIES.md` outline.
 *   - The category dropdown in studio's add/edit forms (with "+ New category"
 *     as an escape hatch).
 *
 * Categories not present in this array fall to the bottom of the list
 * (sorted alphabetically). To re-order or rename, edit this file directly
 * — it's hand-maintained, not regenerated.
 *
 * See plan: ancient-percolating-lantern.md §G + §I.
 */
export const STORAGE_CATEGORIES: readonly string[] = [
  "Locations",
  "Units, Sizing, and Pricing",
  "Policies and Requirements",
  "Move-in Logistics and Supplies",
  "Reservations and Lead Capture",
  "Identity and Verification",
  "Account and Billing",
  "Unit Lifecycle and Transfers",
  "Access, Gate Codes, and Locks",
  "Issues, Emergencies, and Claims",
  "Moveout and Account Closure",
  "Delinquency, Liens, and Auctions (Tenant Side)",
  "Auctions (Buyer / Public Side)",
  "Vehicle and RV Storage",
  "Business Users",
  "Accessibility and Language",
  "Estate / Death of an Account Holder",
  "Privacy and Data",
  "Outbound (Sequence) Responses",
  "Handoff and Escalation",
  "Conversation and Bot Meta",
  "Channel-Specific Actions",
  "End-to-End Conversations"
] as const;

/**
 * Returns the category's order index (lower = earlier). Categories not in the
 * canonical list get `Number.MAX_SAFE_INTEGER` so they sort to the end.
 */
export function storageCategoryOrder(category: string): number {
  const i = STORAGE_CATEGORIES.indexOf(category);
  return i === -1 ? Number.MAX_SAFE_INTEGER : i;
}
